import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import axios from 'axios';
import cssVars from 'css-vars-ponyfill';

import store from 'src/store';
import getVagueEnvironment from 'src/util/environment';
import { setAxiosDefaults } from 'src/util/axios';
import { init as initPretender } from 'src/pretender';
import config from 'src/config/app';
import '@pagerduty/design-system/dist/standalone.ns.css';

// toggle this to true if testing locally and you want to see the widget in a full page layout
const embedFullPageForTest = false;

const vagueEnvironment = getVagueEnvironment();

setAxiosDefaults(axios);

if (vagueEnvironment === 'development') {
  initPretender();
}

// make css vars work in older browsers
cssVars({
  // set this to false to see the effects in Chrome
  onlyLegacy: true
});


const RUNNER_KEY = `${config.APP_NAME}_runner`;
const DESTROYER_KEY = `${config.APP_NAME}_destroyer`;

window[RUNNER_KEY] = (opts, targetElementId) => {
  const props = { ...opts, className: 'apply-design-system' };
  /* eslint-disable global-require */
  const AppComponent = process.env.NODE_ENV === 'development' && embedFullPageForTest
    ? require('src/components/App/AppLocal').default
    : require('src/components/App').default;
  ReactDOM.render(
    <Provider store={store}>
      <AppComponent {...props} />
    </Provider>,
    document.getElementById(targetElementId)
  );
};

window[DESTROYER_KEY] = (opts, targetElementId) => {
  ReactDOM.unmountComponentAtNode(document.getElementById(targetElementId));
};

if (!window[`_${config.APP_NAME}_embed`]) {
  window[RUNNER_KEY]({}, 'root');
}
